const c = (e) => e ? {
  userId: e.userId,
  isAuthenticated: e.isAuthenticated,
  isGuest: e.isGuest,
  accessToken: s(e.accessToken),
  refreshToken: s(e.refreshToken)
} : void 0, s = (e) => e ? `***${e == null ? void 0 : e.slice(-5)}` : void 0, d = (e) => e ? {
  id: e.id,
  userID: e.userID,
  exp: e.exp
} : void 0;
export {
  c as redactState,
  s as redactToken,
  d as redactTokenData
};
